<template>
  <c-container>
    <c-row class="my-3">
      <c-col>
        <h2>Dziękujemy za zamówienie!</h2>
      </c-col>
    </c-row>
    <c-row class="my-2">
      <c-col>
        <p class="lead">Twoje zamówienie zostało pomyślnie złożone.</p>
        <p>Przypisany numer zamówienia: <strong>{{ orderId }}</strong></p>
        <p>Planowany termin dostawy: <strong>{{ deliveryDate }}</strong></p>
        <p v-if="paymentMethod === 'TR'">
          Wybrana forma płatności to przelew. Prosimy o wykonanie płatności na numer BLIK lub konto:
          <strong>{{ bankAccount }}</strong>
        </p>
        <p v-else>
          Wybrana forma płatności to płatność gotówką przy odbiorze.
        </p>
      </c-col>
    </c-row>
    <c-row class="my-3">
      <c-col>
        <c-button color="primary" @click="$router.push('/')">
          Wróć do strony głównej
        </c-button>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
export default {
  name: 'SuccessPage',
  computed: {
    orderId() {
      return this.$store.state.successOrderId
    },
    deliveryDate() {
      return this.$store.state.successDeliveryDate
    },
    paymentMethod() {
      return this.$store.state.successPaymentMethod
    },
    bankAccount() {
      return this.$store.state.successBankAccount
    }
  }
}
</script>